import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  SelectField,
} from 'react-admin';
import { Pagination } from '../../Components';
import PlotFilters from './filters';
import { status } from '../../utils/choices';

const PlotList = (props) => (
  <List
    bulkActionButtons={false}
    exporter={false}
    filters={<PlotFilters />}
    {...props}
    pagination={<Pagination />}
    perPage={50}
  >
    <Datagrid>
      <TextField source="name" label="Plot name" sortable={false} />
      <SelectField source="status" choices={status} sortable={false} />
      <EditButton />
    </Datagrid>
  </List>
);

export default PlotList;
